export type SyncProgressStatus =
  | 'idle'
  | 'syncing'
  | 'paused'
  | 'success'
  | 'partial_failure';

export type SyncProgressItemType = 'operating_hours' | 'issue' | 'periodic_check';

export type SyncProgressItemStatus = 'waiting' | 'uploading' | 'done' | 'failed';

export type SyncProgressItem = {
  id: number;
  type: SyncProgressItemType;
  /** Machine intern shown in list labels. */
  machineIntern?: string;
  status: SyncProgressItemStatus;
};

export type SyncProgressState = {
  status: SyncProgressStatus;
  total: number;
  completed: number;
  items: SyncProgressItem[];
};

/** Input for {@link startRun} (queue row id + mapped type). */
export type SyncProgressRunItem = {
  id: number;
  type: SyncProgressItemType;
  machineIntern?: string;
};

export const idleSyncProgressState: SyncProgressState = {
  status: 'idle',
  total: 0,
  completed: 0,
  items: [],
};
